export const governmentAllocationsPendingListTableColumns = [
  { label: 'N. do empenho', value: 'office_number' },
  { label: 'Tipo', value: 'kind' },
  { label: 'Valor do empenho', value: 'total_value' },
  { label: 'Período de competência', value: 'applicable_date' },
  { label: 'Empresa', value: 'company' },
  { label: 'Filial', value: 'company_branch' },
  { label: 'Solicitante', value: 'creator' },
  { label: 'Data de upload', value: 'created_at' },
  { label: 'Ações', value: 'actions', className: 'w-9' },
];
